// extracted by mini-css-extract-plugin
module.exports = {"insightOverview":"style_insightOverview__38eyQ","header":"style_header__3PF3a","title":"style_title__15qy3","icon":"style_icon__1I6Wv"};